export const COPILOT_WIDTH = 320;

export const COPILOT_MAX_WIDTH = 1000;

export const COPILOT_HEIGHT = '100%';

export const COPILOT_RESIZER_PREFERENCE_KEY = 'WebApp.CampaignUI.CopilotResizerWidth';

export const getCopilotWidthFromPreference = (isDynamicWidthEnabled?: boolean, preferenceService?: any): number => {
  if (!isDynamicWidthEnabled || !preferenceService) {
    return COPILOT_WIDTH;
  }

  const copilotResizerWidthPreference = preferenceService.findByNameAtUserLevel(COPILOT_RESIZER_PREFERENCE_KEY);
  return parseInt(copilotResizerWidthPreference?.Data ?? COPILOT_WIDTH, 10);
};
